import React, {Component} from "react";
import {connect} from "react-redux";
import {bindActionCreators, Dispatch} from "redux";
import FirebaseKey from "../../components/FirebaseKey/FirebaseKey";
import ContactSuccessModal from "../../components/Modals/ContactSuccessModal/ContactSuccessModal";
import {FormValuesContactExtended} from "../../core/models/custom/formValuesContactExtended";
import {ContactRequest} from "../../core/models/requests/contact.request";
import FirebaseService from "../../core/services/firebaseService/firebase.service";
import {contact, contactReset} from "../../core/services/miscService/contact/actions";
import {ContactState} from "../../core/services/miscService/contact/types";
import {history} from "../../core/utilities/history";
import {IStore} from "../../core/utilities/reducers";
import {router} from "../../core/utilities/router";
import ContactForm from "./ContactForm/ContactForm";
import "./ContactPage.scss";

interface IProps {
  contactState: ContactState;
  contact: (request: ContactRequest) => void;
  contactReset: () => void;
}

class ContactPage extends Component<IProps> {
  
  private handleSubmit(values: FormValuesContactExtended): void {
    this.props.contact({...values});
  }
  
  render() {
    return (
      <div id="contact-page" className="page">
        <div className="page-content">
          <FirebaseKey className="title" firebaseKey={FirebaseService.contact_us_title}/>
          <ContactForm
            isLoading={this.props.contactState.loading}
            callbackSubmit={values => this.handleSubmit(values)}
          />
        </div>
        
        {
          this.props.contactState.data &&
          <ContactSuccessModal
            callback={() => history.push(router.QUESTION)}
          />
        }
      </div>
    );
  }
  
  componentWillUnmount() {
    this.props.contactReset();
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators(
    {
      contact,
      contactReset,
    },
    dispatch
  );
};
const mapStateToProps = (store: IStore) => {
  return {
    contactState: store.contact,
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactPage);
